import { ElementDTOUnion } from '@/model';
import { Diff } from '@/util/object.util';

export enum CanvasHistoryItemType {
  ELEMENT_CHANGE = 'element-change',
  ELEMENT_ADDED = 'element-added',
  ELEMENT_REMOVED = 'element-removed',
  ELEMENT_ORDER_CHANGED = 'element-order-changed',
  ELEMENT_VISIBILITY_CHANGED = 'element-view-changed',
}

export interface ElementChange {
  type: CanvasHistoryItemType.ELEMENT_CHANGE;
  id: string;
  diff: Diff<ElementDTOUnion>;
}

export interface ElementAdded {
  type: CanvasHistoryItemType.ELEMENT_ADDED;
  id: string;
}

export interface ElementRemoved {
  type: CanvasHistoryItemType.ELEMENT_REMOVED;
  index: number;
  id: string;
}

export interface ElementOrderChanged {
  type: CanvasHistoryItemType.ELEMENT_ORDER_CHANGED;
  oldIndex: number;
  newIndex: number;
}

export interface ElementVisibilityChanged {
  type: CanvasHistoryItemType.ELEMENT_VISIBILITY_CHANGED;
  id: string;
  visible: boolean;
}

export type CanvasHistoryItem =
  | ElementChange
  | ElementAdded
  | ElementRemoved
  | ElementOrderChanged
  | ElementVisibilityChanged;
